import { valueDataIsEmpty } from "@smartsuite/automation-conditions";

export const requiredInputData = (value: any): string | undefined => {
  let isEmpty = false;
  if (value === undefined) {
    isEmpty = true;
  } else if (value.value !== undefined && Array.isArray(value.value.values)) {
    const notEmptyValue = valueDataIsEmpty(value.value);
    if (notEmptyValue) {
      isEmpty = true;
    }
  }
  return isEmpty ? "Field is required" : undefined;
};
